export class RelatedTransactionService {
  static $inject = ['WindowModalService'];

  constructor(private WindowModalService: any) {}

  openRelatedTransactionModal(transaction, title) {
    let templateUrl =
      './app/ajs/_shared/components/related-transactions/modals/related-transaction-modal.html';
    let modalParams = {
      item: transaction,
      title: title,
    };

    this.WindowModalService.open(templateUrl, modalParams);
  }
}
